export enum TableStatusEnum {
  OPENED = 'OPENED',
  RUNNING = 'RUNNING',
  CLOSED = 'CLOSED',
}
